import React from 'react';
import { useNotifications } from '../../contexts/NotificationContext';
import Toast from './Toast';

const ToastContainer = () => {
  const { toasts } = useNotifications();

  if (!toasts || toasts?.length === 0) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-[9999] flex flex-col gap-2 pointer-events-none">
      <div className="pointer-events-auto flex flex-col gap-2">
        {toasts?.map(toast => (
          <Toast key={toast?.id} toast={toast} />
        ))}
      </div>
    </div>
  );
};

export default ToastContainer;